import "core-js/modules/es.function.name";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Contains the selectors that select state from the 'UADraftApplications' store object.
 *
 * @namespace DraftApplicationsSelectors
 */

var selectors = function selectors() {
  _classCallCheck(this, selectors);
};

_defineProperty(selectors, "moduleIdentifier", 'UADraftApplications');

_defineProperty(selectors, "featureState", function (state) {
  return state[selectors.moduleIdentifier];
});

_defineProperty(selectors, "selectData", function (state) {
  return selectors.featureState(state).data.payload;
});

_defineProperty(selectors, "isProcessing", function (state) {
  return selectors.featureState(state).isProcessing.payload;
});

_defineProperty(selectors, "selectError", function (state) {
  return selectors.featureState(state).error.payload;
});

_defineProperty(selectors, "sortByMostRecentlyUpdated", function (application, otherApplication) {
  var applicationDate = new Date(application.lastUpdatedOn);
  var otherApplicationDate = new Date(otherApplication.lastUpdatedOn);
  return applicationDate < otherApplicationDate ? 1 : -1;
});

_defineProperty(selectors, "getFullDraftApplicationList", function (state) {
  var draftApplicationsDetailsList = [];
  var completeDraftApplicationsList = selectors.selectData(state);

  if (completeDraftApplicationsList && completeDraftApplicationsList.length > 0) {
    for (var i = 0; i < completeDraftApplicationsList.length; i += 1) {
      var currentDraftApplication = completeDraftApplicationsList[i];

      if (currentDraftApplication.name !== '') {
        draftApplicationsDetailsList.push(currentDraftApplication);
      }
    }
  }

  if (draftApplicationsDetailsList.length > 0) {
    _sortInstanceProperty(draftApplicationsDetailsList).call(draftApplicationsDetailsList, selectors.sortByMostRecentlyUpdated);
  }

  return draftApplicationsDetailsList;
});

_defineProperty(selectors, "filterDraftApplicationByApplicationId", function (draftApplicationId, draftApplicationsList) {
  var matches = [];

  if (draftApplicationsList) {
    matches = _filterInstanceProperty(draftApplicationsList).call(draftApplicationsList, function (application) {
      return application.draft_application_id === draftApplicationId;
    });
  }

  return matches.length > 0 ? matches[0] : null;
});

_defineProperty(selectors, "reducedApplicationList", function (completeDraftApplicationList) {
  var accumulatedDraftApplicationList = [];

  if (completeDraftApplicationList !== null && completeDraftApplicationList !== undefined) {
    if (completeDraftApplicationList.length > 0) {
      _sortInstanceProperty(completeDraftApplicationList).call(completeDraftApplicationList, function (l, r) {
        return l.lastUpdatedOn > r.lastUpdatedOn ? -1 : 1;
      });
    }

    return completeDraftApplicationList;
  }

  return accumulatedDraftApplicationList;
});

_defineProperty(selectors, "sortedByDateSelector", function (leftDraftApplication, rightDraftApplication) {
  return leftDraftApplication.lastUpdatedOn > rightDraftApplication.lastUpdatedOn ? -1 : 1;
});

_defineProperty(selectors, "draftApplicationPodReducerSelector", function (completeDraftApplicationList) {
  return selectors.reducedApplicationList(completeDraftApplicationList);
});

export { selectors as default };